import { render, staticRenderFns } from "./NoteStudentTodo.vue?vue&type=template&id=274c1cda"
import script from "./NoteStudentTodo.vue?vue&type=script&lang=js"
export * from "./NoteStudentTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports